import React, { useContext } from "react"
import { timeSince } from "../../../../services/format"
import { AppContext } from "../../../../contexts/AppContext"

const AuthorHeader = (params) => {
    const { accounts } = useContext(AppContext)

    const getValue = (key) => {
        if (params.email) {
            let account = accounts.find((account) => account.email == params.email)

            let finalKey = {
                name: "fullName"
            }[key] || key

            return account?.[finalKey] || ""
        }

        return params[key] || ""
    }

    const Avatar = () => {
        let names = getValue("name")?.split(" ")
        let firstName = names[0]
        let lastName = names[names.length - 1]
        let twoLetters = `${firstName[0]}${names.length > 1 ? lastName[0] : (firstName[1] || "")}`.toLocaleUpperCase()

        return getValue("avatar") ?
            <img
                src={getValue("avatar")}
                style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    objectFit: "cover",
                }}
            /> :
            <div style={{ width: 60, height: 60, borderRadius: 100, backgroundColor: "#E0E0E0" }} className="flex items-center justify-center">{twoLetters}</div>
    }

    return (
        <div className="flex items-center" style={{ gap: 20 }}>
            <Avatar />

            <div>
                <bds-typo variant="fs-16" bold="light" margin={false}>{getValue("name")}</bds-typo>
                <bds-typo variant="fs-12" bold="light" margin={false}>{timeSince(params.datetime)}</bds-typo>
            </div>
        </div>
    )
}

export default AuthorHeader